<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<span *ngIf="labelText">
  {{ labelText }}
  <span *ngIf="required" class="required"></span>
</span>
<div class="flex flex-row gallery-class" [class.disabled]="disable" [class.invalid]="!isValid() && control?.dirty">
  <span class="prefix" *ngIf="prefix && !prefixIcon">{{ prefix }}</span>
  <mat-icon *ngIf="prefixIcon" class="prefix-icon">{{ prefixIcon }}</mat-icon>
  <input
    #rxInput
    [id]="id + '-input'"
    [type]="type"
    class="flex"
    (blur)="onBlur()"
    (focus)="onFocus($event)"
    [(ngModel)]="value"
    (ngModelChange)="onModelChanged($event)"
    [class.none-right-border]="labelText && value"
    [placeholder]="getPlaceholderText()"
    [disabled]="disable"
    [maxlength]="maxLength"
    [autocomplete]="autocomplete"
    [readonly]="readonly"
  />
  <div class="flex flex-row flex-nosize ml5">
    <label class="flex" [class.required]="isRequired">
      <ng-container *ngIf="(hasInlineInfo || keepPlaceholder) && value?.length > 0">
        {{ getPlaceholderText() }}
      </ng-container>
      <span class="flex-row flex-nosize">
        <rx-icon *ngIf="isPending" name="icon-spinner"></rx-icon>
        <rx-icon
          *ngIf="showReset && value?.length"
          [id]="id + '-reset'"
          class="light reset"
          name="icon-cross-circle-fill"
          (click)="onReset()"
        ></rx-icon>
      </span>
    </label>
  </div>
</div>
